import React from 'react'
import { TableHorizontalScrollControlsProps } from './TableHorizontalScrollControls.types'
import styles from './TableHorizontalScrollControls.module.scss'
import cl from 'classnames'
import { Button } from '../Button'
import { IconOrderAscending } from 'assets'
import { useButtonProps, useIsFocused } from './TableHorizontalScrollControls.utils'

const TableHorizontalScrollControlsComponent = (props: TableHorizontalScrollControlsProps) => {
  const {
    shouldRender,
    scrollLeftButtonProps,
    scrollRightButtonProps
  } = useButtonProps(props)

  const {
    isFocused,
    setOnFocus,
    setOffFocus
  } = useIsFocused(shouldRender)

  if (!shouldRender) return null

  return (
    <div
      className={cl(styles.container, {
        [styles.containerFocused]: isFocused
      }, props.className)}
      style={props.style}
      onMouseEnter={setOnFocus}
      onMouseLeave={setOffFocus}
    >

      <Button
        preset='icon'
        {...scrollLeftButtonProps}
      >
        <IconOrderAscending
          style={{
            transform: 'rotate(-90deg)',
            fill: styles.secondaryContent
          }}
        />
      </Button>

      <Button
        preset='icon'
        {...scrollRightButtonProps}
      >
        <IconOrderAscending
          style={{
            transform: 'rotate(90deg)',
            fill: styles.secondaryContent
          }}
        />
      </Button>

    </div>
  )
}

const TableHorizontalScrollControls = TableHorizontalScrollControlsComponent
export { TableHorizontalScrollControls }
